import { NavBarItem } from 'components/nav-bar';
import { EllipsisText, Icon } from 'components/ui';
import { useRouter } from 'next/router';
import { useMedia } from 'react-use';
import { PATHS } from 'settings/config';
import styled from 'styled-components';
import { globalTheme } from 'styles/global-theme';

const Wrapper = styled.div`
  background-color: ${globalTheme.colors.darkBlue};
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  height: 90px;
`;

const NavItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  position: relative;
  cursor: pointer;
  padding-bottom: 4px;
`;

const IconContainer = styled.div<{ $active: boolean }>`
  width: 38px;
  height: 38px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid
    ${({ $active }) => ($active ? globalTheme.colors.white : 'transparent')};
  background-color: ${({ $active }) =>
    $active ? `${globalTheme.colors.blue}` : 'transparent'};
  transition: all 0.3s ease;
  margin-bottom: 4px;

  svg {
    fill: ${({ $active }) =>
      $active ? globalTheme.colors.white : globalTheme.colors.neutral};
    color: ${({ $active }) =>
      $active ? globalTheme.colors.white : globalTheme.colors.neutral};
    transition: all 0.3s ease;
  }
`;

const Label = styled(EllipsisText)<{ $active: boolean }>`
  font-size: ${globalTheme.fontSizes[0]};
  font-weight: 500;
  color: ${globalTheme.colors.white};
  transition: color 0.3s ease;
`;

const ActiveIndicator = styled.div`
  position: absolute;
  bottom: 5px;
  width: 80%;
  height: 4px;
  background-color: ${globalTheme.colors.white};
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
`;

type Props = {};

export const PwaNavBar = (props: Props) => {
  const router = useRouter();
  const isSmallerDevice = useMedia(`(max-width: 323px)`, true);

  const sellerItems: NavBarItem[] = [
    {
      title: 'Home',
      icon: 'HutIcon',
      href: PATHS.home,
    },
    {
      title: 'Stockbook',
      icon: 'StockbookNewIcon',
      href: PATHS.stockbook.home,
    },
    {
      title: 'Marketplace',
      icon: 'Marketplace',
      href: PATHS.marketplace.listings,
    },
    {
      title: 'My Buy listings',
      icon: 'MyListingsIcon',
      href: PATHS.marketplace.buyListings,
    },
  ];

  const handleItemClick = (path: string) => {
    router.push(path);
  };

  return (
    <Wrapper>
      {sellerItems.map((item) => {
        const routeActive = router.pathname === item.href;
        return (
          <NavItem onClick={() => handleItemClick(item.href)} key={item.title}>
            <IconContainer $active={routeActive}>
              <Icon component={item.icon} size={2} />
            </IconContainer>
            <Label $active={routeActive} textAlign='center'>
              {item.title}
            </Label>
            {routeActive && <ActiveIndicator />}
          </NavItem>
        );
      })}
    </Wrapper>
  );
};
